import React from "react";
import { Container } from "reactstrap";
import PropTypes from "prop-types";

const NotImplemented = props => {
    const { name } = props;

    return (
        <Container>
            <h1>Componente: {name}</h1>
        </Container>
    );
};

NotImplemented.propTypes = {
    name: PropTypes.string.isRequired
};

export { NotImplemented }
